import { Reducer } from 'redux';
import { ESCycle } from '~src/interfaces/cycle.interface';

import { ThunkAnyAction } from '~src/services/apiMiddleware';
import { FetchSurveysCyclesResponse } from '~src/modules/surveys/actions/cyclesActions';
import { typesForFetchSurveysCycles } from '~src/modules/surveys/constants/actionTypes';

export interface SurveysCyclesState {
  data?: Record<string, ESCycle[]>;
  error?: Record<string, string>;
  loading: boolean;
}

export function getInitialCyclesState(): SurveysCyclesState {
  return {
    loading: false,
  };
}

const surveysCyclesReducer: Reducer<SurveysCyclesState, ThunkAnyAction> = (
  state = getInitialCyclesState(),
  action,
) => {
  switch (action.type) {
    case typesForFetchSurveysCycles.Request: {
      return {
        ...state,
        loading: true,
      };
    }
    case typesForFetchSurveysCycles.Success: {
      return {
        ...state,
        loading: false,
        data: getFetchSurveysCyclesData(action.response.data),
      };
    }
    case typesForFetchSurveysCycles.Failed: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export function getFetchSurveysCyclesData<T>(responseData: T): FetchSurveysCyclesResponse | undefined {
  return (
    (responseData &&
      Object.keys(responseData).length &&
      // @ts-ignore
      (responseData as FetchSurveysCyclesResponse)) ||
    undefined
  );
}

export default surveysCyclesReducer;
